import { CssBaseline } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { FC } from 'react'
import { useIdsQuery } from 'src/api/api.generated'
import { useReservationId } from 'src/app/hooks/context/reservationId/reservation-id.hook'
import useErrorSnackBar from 'src/app/hooks/error-snack-bar/use-error-snack-bar'
import useGetTheme from 'src/app/themes/use-get-theme'
import HiCLoading from 'src/app/components/HiCLoading'

export const GuestPortalLayout: FC = ({ children }) => {
  const reservationId = useReservationId()
  const showError = useErrorSnackBar()

  const { data, loading: loadingQuery } = useIdsQuery({ variables: { reservationId }, onError: showError, skip: !reservationId })

  const propertyId = data?.guestPortalReservation?.propertyId?.[0] ?? null
  const tenantId = data?.guestPortalReservation?.tenantId ?? null

  const { theme, loading } = useGetTheme({ propertyId, tenantId })

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {(loading || loadingQuery) && <HiCLoading />}
      {children}
    </ThemeProvider>
  )
}
